import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwo = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.85575 16.8002V15.8354C9.71015 15.0098 10.4446 14.2754 11.059 13.6322C11.683 12.9794 12.163 12.389 12.499 11.861C12.835 11.3234 13.003 10.8242 13.003 10.3634C13.003 9.88339 12.8734 9.49939 12.6142 9.21139C12.355 8.92339 11.9806 8.77939 11.491 8.77939C11.1358 8.77939 10.8094 8.88019 10.5118 9.08179C10.2238 9.28339 9.95495 9.52339 9.70535 9.80179L8.78375 8.88019C9.20615 8.42899 9.64295 8.08339 10.0942 7.84339C10.5454 7.59379 11.083 7.46899 11.707 7.46899C12.5902 7.46899 13.291 7.72339 13.8094 8.23219C14.3374 8.74099 14.6014 9.42259 14.6014 10.277C14.6014 10.8146 14.4478 11.3666 14.1406 11.933C13.843 12.4898 13.4398 13.061 12.931 13.6466C12.4318 14.2322 11.8798 14.8466 11.275 15.4898C11.515 15.4706 11.7742 15.4514 12.0526 15.4322C12.331 15.4034 12.5806 15.389 12.8014 15.389H15.0478V16.8002H8.85575Z",
		fill: "currentcolor"
	})]
});
export default SvgTwo;
